import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { jdsSelectProps } from '../../../../components/jds/selectProps';
import { AddonsAPI } from '../../../../api/payments/addons/api';

export function AddonSelect({ addons, addonsLoading, value, onChange, error }) {
  const [extraOption, setExtraOption] = useState(null);

  // O addon selecionado pode estar fora da primeira página de resultados
  // (limit=100) buscada pelo componente pai; busca-o individualmente nesse
  // caso, sem alterar a lista compartilhada `addons`.
  useEffect(() => {
    if (addonsLoading || !value) return;
    if (addons.some((option) => option.id === value)) {
      setExtraOption(null);
      return;
    }
    AddonsAPI.get(value)
      .then((response) => setExtraOption(response.data))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, addonsLoading, addons]);

  const options =
    extraOption && !addons.some((option) => option.id === extraOption.id)
      ? [...addons, extraOption]
      : addons;

  return (
    <div className="form-group mb-0">
      <label>Selecione o produto</label>
      <Select
        name="addonId"
        isSearchable
        isClearable
        isLoading={addonsLoading}
        placeholder="Buscar..."
        noOptionsMessage={() => 'Nenhum resultado encontrado'}
        options={options}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id}
        value={options.find((option) => option.id === value) || null}
        onChange={(option) => onChange(option ? option.id : '')}
        {...jdsSelectProps}
      />
      {error && <div className="text-danger">{error}</div>}
    </div>
  );
}
